// Leyenda del tipo de caso que tiene una agenda (campo Tipo de la agenda).
const ETIQUETAS = {
  "PRE-JUDICIAL": "Pre-Judicial",
  "JUDICIAL": "Judicial",
  "CUALITATIVO": "Cualitativo",
};

export const etiquetaTipoCaso = (tipo) => ETIQUETAS[(tipo || "").toUpperCase()] || tipo || "";
